import { useEffect } from 'react';

export default function GoogleTranslate() {
    useEffect(() => {
        const addGoogleTranslateScript = () => {
            if (document.getElementById('google-translate-script')) return;

            window.googleTranslateElementInit = () => {
                new window.google.translate.TranslateElement(
                    {
                        pageLanguage: 'en',
                        includedLanguages: 'es',
                        layout: window.google.translate.TranslateElement
                            .InlineLayout.SIMPLE,
                    },
                    'google_translate_element',
                );
            };

            const script = document.createElement('script');
            script.id = 'google-translate-script';
            script.src =
                'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
            document.body.appendChild(script);
        };

        addGoogleTranslateScript();

        return () => {
            const script = document.getElementById('google-translate-script');
            if (script) {
                script.remove();
            }
            const container = document.getElementById(
                'google_translate_element',
            );
            if (container) {
                container.innerHTML = '';
            }
            delete window.googleTranslateElementInit;
        };
    }, []);

    return <div id="google_translate_element" />;
}
